import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { get } from "lodash";

import Icons from "../../components/icons";
import { ICONS } from "../../constants/icons.constants";
import { authHelpers, generalHelpers } from "../../helpers";
import {
  AbsoluteWrapper,
  Button,
  DatePicker,
  Dropdown,
  ImagePicker,
  Input,
} from "../../kaya";
import OtpScreen from "../../components/otpScreen";
import { generalConstants, routesConstants } from "../../constants";
import { userActions } from "../../actions";
import userStore from "../../zustand/user.store";
import logo from "../../assets/Logo.png";
import DropdownWithInput from "../../components/dropdownWithInput/DropdownWithInput";

import styles from "./PersonalInfo.module.scss";

const PersonalInfo = () => {
  const navigate = useNavigate();

  const { setUser, user, setAuthentication, userOffline } = userStore(
    (state) => ({
      setUser: state.setUser,
      user: state.user,
      defaultUser: state.defaultUser,
      setAuthentication: state.setAuthentication,
      authenticate: state.authenticate,
      userOffline: state.userOffline,
    })
  );

  const [formValues, setFormValues] = useState({
    first_name: "",
    last_name: "",
    // national_identity_no: "",
    phone: {
      code: "+972",
      number: "",
    },
    stage_name: "",
    description: "",
    birthday: "",
    address: "",
    city: "",
    country: "",
    occupation: "",
    other: "",
    username: "",
    profile_img: "",
    profile_img_url: "",
  });

  const [datePickerVisible, setDatePickerVisible] = useState(false);

  const [visible, setVisible] = React.useState(false);
  const [token, setToken] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState({
    first_name: "",
    last_name: "",
    username: "",
    // national_identity_no: "",
    phone: "",
    stage_name: "",
    description: "",
    birthday: "",
    address: "",
    city: "",
    country: "",
    occupation: "",
    other: "",
  });

  const handleSubmit = async (otp) => {
    setLoading(true);
    const isSuccess = await userActions.verifyOtpAction({
      otp,
      token,
      userOffline,
    });

    if (!isSuccess.success) {
      setLoading(false);
      return;
    }

    setVisible(false);

    const promises = [];
    const updateUserPromise = userActions.updatePersonalInfoAction(
      {
        first_name: get(formValues, "first_name", ""),
        last_name: get(formValues, "last_name", ""),
        username: get(formValues, "username", ""),
        // national_identity_no: get(formValues, "national_identity_no", ""),
        // stage_name: get(formValues, "stage_name", ""),
        description: get(formValues, "description", ""),
        birthday: get(formValues, "birthday"),
        address: get(formValues, "address", ""),
        city: get(formValues, "city", ""),
        country: get(formValues, "country.value", ""),
        occupation:
          formValues.occupation.value === "Other"
            ? get(formValues, "other", "")
            : get(formValues, "occupation.value", ""),
      },
      user.id,
      userOffline
    );
    promises.push(updateUserPromise);

    if (formValues.profile_img) {
      const avatarUploadPromise = userActions.avatarUploadAction(
        formValues.profile_img,
        user.id,
        userOffline
      );
      promises.push(avatarUploadPromise);
    }

    // Execute all promises and wait for them to settle
    const results = await Promise.allSettled(promises);

    // Extracting specific results if needed
    const [updateArtistResult, avatarResult] = results;

    if (updateArtistResult?.status === "fulfilled") {
      setUser({
        ...user,
        ...get(updateArtistResult, "value.data", {}),
      });
      setAuthentication({
        isAuthenticated: true,
        isPhoneVerified: true,
        isBusinessVerified: false,
        isPrimium: false,
      });
      navigate(routesConstants.ROUTES.BUSINESS_INFO);
    }

    if (
      avatarResult?.status === "fulfilled" &&
      avatarResult?.value?.success === true
    ) {
      setUser((prevUser) => ({
        ...prevUser,
        ...get(avatarResult, "value.data", {}),
      }));
    }

    setLoading(false);
  };

  const handleChange = (id) => (value) => {
    if (typeof id !== "object") {
      setFormValues({
        ...formValues,
        [id]: value,
      });
      setErr({
        ...err,
        [id]: "",
      });
    } else {
      setFormValues({
        ...formValues,
        ...id,
      });
      setErr({
        ...err,
        ...id,
      });
    }
  };

  const handleNextStep = async () => {
    const error = {
      first_name: authHelpers.validateFirstName(get(formValues, "first_name")),
      last_name: authHelpers.validateLastName(get(formValues, "last_name")),
      username: authHelpers.validateUsername(get(formValues, "username")),
      // national_identity_no: authHelpers.validateNationalNo(
      //   get(formValues, "national_identity_no", "")
      // ),
      phone: authHelpers.validatePhone(get(formValues, "phone.number")),
      // stage_name: authHelpers.validateStageName(get(formValues, 'stage_name')),
      // description: authHelpers.validateDescription(get(formValues, 'description')),
      birthday: authHelpers.validateDate(get(formValues, "birthday")),
      address: authHelpers.validatePersonalAddress(get(formValues, "address")),
      city: authHelpers.validateCity(get(formValues, "city")),
      country: authHelpers.validateCountry(
        get(formValues, "country.value", "")
      ),
      occupation: authHelpers.validateOccupation(
        get(formValues, "occupation.value", "")
      ),
      other:
        formValues.occupation.value === "Other"
          ? authHelpers.otherOption(formValues.other)
          : "",
    };

    if (!generalHelpers.isEmptyErrors(error)) {
      setErr({
        ...err,
        ...error,
      });
      return;
    }
    setLoading(true);

    // write api call here
    const data = await userActions.sendOtpAction(
      {
        phone_no: formValues.phone.number,
        phone_no_code: formValues.phone.code,
      },
      userOffline
    );
    if (data.success) {
      setToken(data.data.token);
    }

    setLoading(false);
    setVisible(true);
  };

  return visible ? (
    <OtpScreen
      phoneNumber={formValues.phone.number}
      visible={visible}
      handleVerify={handleSubmit}
      handleResend={handleNextStep}
      setVisible={() => {
        setVisible(false);
        navigate(routesConstants.ROUTES.BUSINESS_INFO);
      }}
      handleSubmit={handleSubmit}
      isLoading={loading}
    />
  ) : (
    <div className={styles.PersonalInfo}>
      <div className={styles.logo}>
        {/* <Icons type={ICONS.LOGO} /> */}
        <img src={logo} alt="" />
      </div>

      <div className={styles.box}>
        <h1 className={styles.title}>Personals Information</h1>
        <ImagePicker
          profileImgUrl={formValues.profile_img_url || ""}
          onChange={handleChange}
        />
        <div className={styles.name}>
          <Input
            containerClassName={styles.input1}
            placeholder="First Name"
            value={formValues.first_name}
            onChange={handleChange("first_name")}
            width="100%"
            errors={err}
            id="first_name"
          />
          <Input
            containerClassName={styles.input2}
            placeholder="Last Name"
            value={formValues.last_name}
            onChange={handleChange("last_name")}
            errors={err}
            id="last_name"
            width="100%"
          />
        </div>
        <Input
          type="string"
          width="100%"
          placeholder="Username"
          value={formValues.username}
          onChange={handleChange("username")}
          errors={err}
          id="username"
        />
        <Input
          type="string"
          width="100%"
          placeholder="Address"
          value={formValues.address}
          onChange={handleChange("address")}
          errors={err}
          id="address"
        />
        <Input
          type="string"
          width="100%"
          placeholder="City"
          value={formValues.city}
          onChange={handleChange("city")}
          errors={err}
          id="city"
        />
        <Dropdown
          className={styles.dropDown}
          placeholder="Country"
          options={generalConstants.countries}
          value={formValues.country}
          errors={err}
          id="country"
          onMenuItemClick={handleChange("country")}
        />
        <Dropdown
          className={styles.dropDown}
          placeholder="Industry"
          options={generalConstants.personalOccupations}
          value={formValues.occupation}
          errors={err}
          id="occupation"
          onMenuItemClick={handleChange("occupation")}
        />
        {formValues.occupation.value === "Other" && (
          <Input
            type="string"
            width="100%"
            placeholder="Occupation"
            value={formValues.other}
            onChange={handleChange("other")}
            errors={err}
            id="other"
          />
        )}

        <AbsoluteWrapper
          componentToTrigger={
            <Input
              placeholder="Birthdate"
              // onChange={() => {
              //   setVisible(true);
              // }}
              value={
                formValues.birthday &&
                generalHelpers.formatDateAccordingToDateType(
                  formValues.birthday
                )
              }
              suffixIcon={<Icons type={ICONS.CALENDAR} />}
              width="476px"
              errors={err}
              id="birthday"
              // onClick={() => {
              //   setDatePickerVisible(true);
              // }}
            />
          }
          placement="bottomLeft"
        >
          <DatePicker
            setDate={handleChange("birthday")}
            date={!formValues.birthday ? new Date() : formValues.birthday}
            visible={datePickerVisible}
            setVisible={setDatePickerVisible}
          />
        </AbsoluteWrapper>

        {/* <Input
          type="number"
          width="100%"
          placeholder="National Identity No."
          value={formValues.national_identity_no}
          onChange={handleChange("national_identity_no")}
          maxLength={9}
          errors={err}
          id="national_identity_no"
        /> */}
        {/* <Input
          type="number"
          width="100%"
          placeholder="Phone No."
          maxLength={9}
          value={formValues.phone_no}
          onChange={handleChange('phone_no')}
          errors={err}
          id="phone_no"
        /> */}

        <DropdownWithInput
          error={err.phone}
          onChange={handleChange}
          phone={formValues.phone}
        />
        {/* <Input
          width="100%"
          placeholder="Stage Name (Optional)"
          value={formValues.stage_name}
          onChange={handleChange("stage_name")}
          errors={err}
          id="stage_name"
        /> */}
        {/* <Textarea
          className={styles.input6}
          placeHolder="Description (Optional)"
          value={formValues.description}
          onChange={handleChange("description")}
          error={err.description}
          onEnterClick={handleNextStep}
        /> */}
        <Button
          className={styles.btn}
          onClick={handleNextStep}
          isLoading={loading}
          type="Primary"
        >
          Next Step
        </Button>
      </div>
    </div>
  );
};

export default PersonalInfo;
